import React, { useEffect, useRef, useState } from "react";
import "../../modal.css";
// import "../../styles.css"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MessageType } from "../../constants";
import { numDifferentiation } from "../../utils";

export default function TravelPlanDetails({ message, ViewPlanDetails, contactSupport, mainMenu, content }) {
    const [maxHeight, setMaxHeight] = useState("")
    const [featureHeight, setFeatureHeight] = useState("")
    const settings = {
        adaptiveHeight: false,
        dots: true,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        className: "plan-differences-slider"
    };
    const ref = useRef(null)
    useEffect(() => {
        let div = document.querySelectorAll('.plan-info');
        let divHeight = []
        for (let element of div) {
            divHeight.push(element.offsetHeight)
        }
        setMaxHeight(Math.max(...divHeight))
        let feature = document.querySelectorAll('.sp-annouce');
        let featureHeight = []
        for (let element of feature) {
            featureHeight.push(element.offsetHeight)
        }
        setFeatureHeight(Math.max(...featureHeight))

    })
    return (
        <>
            {content && content.title ?
                <div className="grop_message">
                    <div
                        className="message"
                        dangerouslySetInnerHTML={{ __html: content.title }}
                    />
                </div>
                : null}
            <div className="slider-list card  withlabel ">
                <Slider  {...settings}>
                    {content && content.plans ? content.plans.map((item) =>
                        <div className="card" key={item.plan_id}>
                            <div className="plan-info" style={{ minHeight: maxHeight }} ref={ref}>
                                <div className="logo card-item">
                                    <div className="ins-logo"><img src={item.image_link} /></div>
                                </div>
                                <div className="insuer-info card-item">
                                    <p className={`heading  ${item.plan_name.length >= 30 ? "morechar" : "lesschar"} `}>{item.plan_name}</p>
                                    <p className="highlight" onClick={() => ViewPlanDetails(item)}>{"View all features"}</p>
                                </div>
                                <div className="cover card-item">
                                    <p className="small">Cover Amount</p>
                                    <p className="heading">&#x20b9; {numDifferentiation(item.sum_insured)}</p>
                                </div>
                                <div className="premium card-item">
                                    <p className="small">Premium</p>
                                    <p className="heading">&#x20b9; {item.final_premium.toLocaleString('en-IN')}/<span>year</span></p>
                                </div>
                            </div>
                            {item.feature_text ?
                                <div className="sp-annouce" style={{ minHeight: featureHeight }}>
                                    <span class="love-text"><i></i> What we love?</span>
                                    <div dangerouslySetInnerHTML={{ __html: item.feature_text }} />
                                </div>
                                : null}
                        </div>
                    ) : null}
                </Slider>
            </div>
            {content && content.quotes_link ?
                <div className="grop_message tabq">
                    <a href={content.quotes_link} target="_blank">
                        <div className="question ">
                            {"View More"}
                        </div>
                    </a>
                </div>
                : null}
            {message && !message.selected ?
                <>
                    <div className="grop_message tabq">
                        <div onClick={() => contactSupport(message.messageId)} className="question ">
                            {"Support"}
                        </div>
                    </div>
                    <div className="grop_message tabq">
                        <div onClick={() => mainMenu(message.messageId)} className="question ">
                            {"Main Menu"}
                        </div>
                    </div>
                </>
                : null}

        </>
    );
}

